<section>
    <div class="grid-filter">
        <label class="radio1">
            <input type="radio" name="statistic" [(ngModel)]="statisticType" value="all" (change)="fetchFilter()"/>
            <span></span>
            All
        </label>
        <label class="radio1">
            <input type="radio" name="statistic" [(ngModel)]="statisticType" value="today" (change)="fetchFilter()"/>
            <span></span>
            Today
        </label>
        <label class="radio1">
            <input type="radio" name="statistic" [(ngModel)]="statisticType" value="yesterday" (change)="fetchFilter()"/>
            <span></span>
            Yesterday
        </label>
        <label class="radio1">
            <input type="radio" name="statistic" [(ngModel)]="statisticType" value="thisWeek" (change)="fetchFilter()"/>
            <span></span>
            This Week
        </label>
        <label class="radio1">
            <input type="radio" name="statistic" [(ngModel)]="statisticType" value="lastWeek" (change)="fetchFilter()"/>
            <span></span>
            Last Week
        </label>
        <label class="radio1">
            <input type="radio" name="statistic" [(ngModel)]="statisticType" value="thisMon" (change)="fetchFilter()"/>
            <span></span>
            This Month
        </label>
        <label class="radio1">
            <input type="radio" name="statistic" [(ngModel)]="statisticType" value="lastMon" (change)="fetchFilter()"/>
            <span></span>
            Last Month
        </label>
    </div>
    <form class="form-horizontal padder">
        <!--<div class="row  m-b-1">-->
        <div class="grid-add-wrap">
            <grid-cmp [attributes]=attributes [storeValue]=storeValue [parameters]=parameters [storeObj]=storeObject [action]=action
                (actionRequest)="onActionRequest($event)" (detailVisible)="onShowDetails($event)"></grid-cmp>
        </div>
        <!--<div *ngIf="detailVisible" class="col-sm-4">
            </div>-->
        <!--</div>-->
    </form>
    <details-cmp [id]=statisticID [viewDetails]=viewDetails [storeValue]=storeValue [label]="'Statistics'" [store]=storeObject [show]=showDetails (onViewClose)="viewClosed($event)"></details-cmp>
</section>

<!--[class.col-sm-10]="!detailVisible" [class.col-sm-8]="detailVisible"-->